<template>
	<div>
		<div>
			<WindowForAlert
				:btnCancel="false"
				ref="windowForAlert"
				:title="title"
			>
				<div
					class="mb105x"
					v-for="(item, index) in paramsList"
					:key="index"
				>
					<span class="fsField">{{ item.name }}: </span>
					<span>{{ item.value }}</span>
				</div>
				<button @click="hide()" slot="btmBtn" class="functionBtn">
					{{ getLanguageStr("device220", "我知道了") }}
				</button>
			</WindowForAlert>
		</div>
	</div>
</template>

<script>
import { getLanguageStr } from "@/util/language";
export default {
	name: "ParamResult",
	props: {},
	data() {
		return {
			stage,
			title: "",
			paramsList: [],
			resultDialog: false,
			resultMList: [],
			resultMTitle: ""
		};
	},
	methods: {
		getLanguageStr,
		show(data) {
			const { list, title } = data;
			this.title = title;
			this.paramsList = list;
			this.$nextTick(() => {
				this.$refs.windowForAlert.show();
			});
		},
		hide() {
			this.$refs.windowForAlert.hide();
		}
	},
	created() {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/view/device/device/part/ParamResult.vue